import { render, staticRenderFns } from "./CustomerInvoices.vue?vue&type=template&id=013aea8d&"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports